import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import Popup from '@Components/Popups/Popup'
import React, { useContext, useState } from 'react'
import { StoresContext } from '@App/contexts'
import './index.scss'
import BulkRelinquishmentSubmittedPopup from '@Components/Popups/ConfirmationPopup/BulkRelinquishmentConfirmationPopup/BulkRelinquishmentSubmittedPopup'
import { OverclaimBulkRelinquishment } from '@Entities/overclaim/overclaim-bulk-relinquishment'

export interface BulkRelinquishmentConfirmationPopupProps {
    onClose: () => void
}

const BulkRelinquishmentConfirmationPopup = (props: BulkRelinquishmentConfirmationPopupProps) => {
    const [hasConfirmed, setHasConfirmed] = useState(false)
    const [bulkRelinquishmentResults, setBulkRelinquishmentResults] = useState<OverclaimBulkRelinquishment>()
    const { overclaimSearchStore, overclaimSearchBulkActionStore, preloaderStore, userStore } =
        useContext(StoresContext)
    const { onClose } = props

    const onCancel = async () => {
        preloaderStore.openTransparentPreloader(true)
        await overclaimSearchStore.searchForWorks(overclaimSearchStore.pagination)
        overclaimSearchBulkActionStore.resetSelection()
        setHasConfirmed(false)
        onClose()
        preloaderStore.openTransparentPreloader(false)
    }

    const submitBulkRelinquishment = async () => {
        preloaderStore.openTransparentPreloader(true)
        overclaimSearchBulkActionStore
            .submitBulkRelinquishment()
            .then((result) => {
                setHasConfirmed(true)
                setBulkRelinquishmentResults(result.data)
                overclaimSearchStore.searchForWorks(overclaimSearchStore.pagination)
                overclaimSearchBulkActionStore.resetSelection()
            })
            .finally(() => {
                preloaderStore.openTransparentPreloader(false)
            })
    }

    return (
        <Popup className="bulk-overclaim-action-popup" onClose={hasConfirmed ? onCancel : onClose}>
            {!hasConfirmed ? (
                <ConfirmationPopup
                    title="Relinquish Work"
                    popupClassName="bulk-relinquishment-confirmation-popup"
                    onCancel={onClose}
                    cancelButtonText="Cancel"
                    confirmButtonText="Confirm"
                    onConfirm={submitBulkRelinquishment}
                    disabled={userStore.isInternal}
                >
                    Clicking "Confirm" below will relinquish all claimed shares by the claimant on the selected works.
                </ConfirmationPopup>
            ) : (
                <BulkRelinquishmentSubmittedPopup
                    onCancel={onCancel}
                    bulkRelinquishmentResults={bulkRelinquishmentResults}
                    totalWorks={bulkRelinquishmentResults?.totalCount}
                />
            )}
        </Popup>
    )
}
export default BulkRelinquishmentConfirmationPopup
